<template>
  <!-- 数字产业集聚区 -->
  <div>
    <!-- 顶部背景图 -->
    <div class="SzcyJjq-top"></div>
    <!-- 物润财税服务 -->
    <div class="WrCsfw">
      <p class="Title">物润财税服务</p>
      <p class="min-Title">通过稳定且优质的税源，形成规模效应帮助客户合规降本</p>
      <div class="div">
        <div class="div0"></div>
        <div class="div1">
          <p class="div1-p">平台拥有10+合作基地</p>
          <div class="div1-1">
            <img src="../../assets/szcyGatheringArea/wrcsfw-hzjd.png" alt="" />
          </div>
        </div>
        <div class="div1">
          <p class="div1-p">产业优势</p>
          <div class="div1-2">
            <p class="colorp">
              规上工业总产值4811亿元，口岸货物吞吐量2.5亿吨、外贸运量6480万吨、一般贸易进出口1838.7亿元，重点发展“4+4”主导产业向产业链两端延伸、向价值链高端攀升。
            </p>
            <img src="../../assets/szcyGatheringArea/wrcsfw-cyys.png" alt="" />
            <p class="wucolorp" style="line-height: 22px;">
              聚焦冶金新材料、智能装备、化工新材料、高端纺织等4条特色优势产业链，重点推进沿江钢铁精品基地、国泰智能制造产业基地、锂电池材料生产研发基地等项目建设；聚焦新能源、数字经济、特色半导体、生物医药及高端医疗器械等4条新兴产业链，大力推进海进江LNG接收站、华灿光电LED照明产业基地、凡润液晶显示模组等重点项目建设。
            </p>
          </div>
        </div>
        <div class="div1">
          <p class="div1-p">功能优势</p>
          <div class="div1-3">
            <p class="colorp">国家制定优惠政策，先行先试</p>
            <img src="../../assets/szcyGatheringArea/wrcsfw-gnys.png" alt="" />
            <p class="wucolorp" style="line-height: 26px;">
              张家港产业聚集区属于特殊经济区域，可享受国家制定的各类优惠政策，各项政策都可以以很开放的姿态去做到先行先试。
            </p>
          </div>
        </div>
        <div class="div0"></div>
      </div>
      <div class="div">
        <div class="div0"></div>
        <div class="div1" style="width: 1308px">
          <p class="div1-p">落地优势</p>
          <div class="div1-1 div-dan">
            <img src="../../assets/szcyGatheringArea/wrcsfw-ldys-gsq.png" alt="" />
            <img src="../../assets/szcyGatheringArea/wrcsfw-ldys-gsx.png" alt="" />
            <img src="../../assets/szcyGatheringArea/wrcsfw-ldys-gzy.png" alt="" />
          </div>
        </div>
        <div class="div0"></div>
      </div>
    </div>

    <!-- 数字产业综合服务解决方案 -->
    <div class="SzcyZhfwJjfa">
      <p class="Title">数字产业综合服务解决方案</p>
      <!-- <p class="min-Title">通过稳定且优质的税源，形成规模效应帮助客户合规降本</p> -->
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2"></div>
        <div class="div0 div6"></div>
      </div>
    </div>
    <!-- 基于网络货运服务的七大优势 -->
    <div class="JyWlhyfuDqdys">
      <p class="Title">基于网络货运服务的七大优势</p>
      <div class="div">
        <div class="div0 div1"></div>
        <div class="div0 div2"></div>
        <div class="div0 div6"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
// 顶部背景
.SzcyJjq-top {
  background: url("../../assets/szcyGatheringArea/szcyGatheringArea-banner.png") center
    center no-repeat;
  height: 662px;
}
/* 物润财税服务开始 */
.WrCsfw {
  color: #333333;
  background: #ffffff;
  font-family: Microsoft YaHei;
  font-weight: 400;
  padding-bottom: 99px;
}
.WrCsfw > .Title {
  font-size: 35px;
  color: #000000;
  text-align: center;
  padding: 70px 0 30px 0;
}
.WrCsfw > .min-Title {
  font-size: 19px;
  color: #666666;
  line-height: 35px;
}
.WrCsfw > .div {
  display: flex;
  padding: 0 5%;
  justify-content: space-between;
  margin-top: 30px;
}

.WrCsfw > .div .div0 {
  flex: 1;
  padding: 0 20px;
}
.WrCsfw > .div .div1 {
  padding: 20px;
  margin: 0 20px;
  width: 383px;
  background: #ffffff;
  box-shadow: 0px 1px 17px 1px rgba(93, 93, 93, 0.13);
  border-radius: 10px;
  display: flex;
  position: relative;
  .div1-p {
    position: absolute;
    left: 0;
    top: 30px;
    display: inline-block;
    font-size: 22px;
    font-weight: 400;
    color: #ffffff;
    padding: 10px 24px;
    background: #2f82ff;
    border-radius: 0px 25px 25px 0px;
  }
}
.WrCsfw > .div .div1 .div1-1,
.WrCsfw > .div .div1 .div1-2,
.WrCsfw > .div .div1 .div1-3 {
  width: 100%;
  padding-top: 50px;
  margin: auto;
  font-size: 24px;
  color: #373d41;
  .colorp {
    text-align: left;
    margin: 20px 0;
    padding: 10px 20px;
    font-size: 14px;
    line-height: 16px;
    color: #666666;
    background: #ebf2fd;
  }
  .wucolorp {
    text-align: left;
    margin-top: 20px;
    padding: 0 20px;
    font-size: 14px;
    line-height: 16px;
    color: #666666;
  }
}
.WrCsfw > .div .div1 .div1-2,
.WrCsfw > .div .div1 .div1-3 {
  margin: 0 auto;
}
.WrCsfw > .div .div1 .div1-1 img {
  width: 360px;
  height: 284px;
}
.WrCsfw > .div .div1 .div1-2 img {
  width: 216px;
  height: 120px;
}
.WrCsfw > .div .div1 .div-dan{
  display: flex;
  justify-content: space-between;
}
.WrCsfw > .div .div1 .div-dan img {
  flex-shrink:0;
  margin:auto;
  padding: 0 15px;
  // margin:0 15px;
  margin-top:40px;
  width: 365px;
  height: 256px;
}
/* 物润财税服务结束 */
/* 数字产业综合服务解决方案开始 */
.SzcyZhfwJjfa {
  background: #f5f7fa;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.SzcyZhfwJjfa > .min-Title {
  font-size: 19px;
  color: #666666;
  line-height: 35px;
}
.SzcyZhfwJjfa > .Title {
  font-size: 35px;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.SzcyZhfwJjfa > .div {
  display: flex;
}

.SzcyZhfwJjfa > .div .div1,
.SzcyZhfwJjfa > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.SzcyZhfwJjfa > .div .div2 {
  margin: 50px 0 80px 0;
  width: 1228px;
  height: 980px;
  background: url("../../assets/szcyGatheringArea/szcyzhfwjufa.png") center center
    no-repeat;
}
/* 数字产业综合服务解决方案结束 */
/* 基于网络货运服务的七大优势开始 */
.JyWlhyfuDqdys {
  background: #ffffff;
}
.JyWlhyfuDqdys > .Title {
  font-size: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  text-align: center;
  padding: 70px 0 20px 0;
}
.JyWlhyfuDqdys > .div {
  display: flex;
}

.JyWlhyfuDqdys > .div .div1,
.JyWlhyfuDqdys > .div .div6 {
  flex: 1;
  margin: 0 17px;
}
.JyWlhyfuDqdys > .div .div2 {
  margin: 50px 0 80px 0;
  width: 1232px;
  height: 572px;
  background: url("../../assets/szcyGatheringArea/jywlhyfwdqdys.png") center center
    no-repeat;
}
/* 基于网络货运服务的七大优势结束 */
</style>
